<template>
  <div class="BizFooter">
    <i class="footer-icon" @click="goTop"/>
    <div class="footer-nav">
      <template v-for="(item, index) in footerNavList">
        <template v-if="index+1 === fistLineNum || index+1 === footerNavList.length">
          <a v-if="item.ref"
             :href="item.url"
             :key="index"
             :rel="item.ref"
             @click.prevent="itemClick(item, index)"
          >{{ item.title }}</a>
          <a v-else
             :href="item.url"
             :key="index"
             @click.prevent="itemClick(item, index)"
          >{{ item.title }}</a>
          <br :key="'br'+index">
        </template>
        <template v-else>
          <a v-if="item.ref"
             :href="item.url"
             :key="index"
             :rel="item.ref"
             @click.prevent="itemClick(item, index)"
          >{{ item.title }}</a>
          <a v-else
             :href="item.url"
             :key="index"
             @click.prevent="itemClick(item, index)"
          >{{ item.title }}</a>
          <em :key="'em'+index">|</em>
        </template>
      </template>
    </div>
    <span class="footer-copyright">Copyright&nbsp;©&nbsp;2007-{{ year }}&nbsp;Anjuke.com&nbsp;沪B2-20090008</span>
  </div>
</template>
<script>
import { concatSoj } from '../../utils/common/base';

export default {
  name: 'BizFooter',
  props: {
    /**
     * 导航数据示例
     * [{
          url: `//mobile.anjuke.com`,
          title: '全国新房',
        },
        {
          url: `//feedback/`,
          title: '意见反馈',
          ref: 'nofollow',
        }]
     */
    footerNavList: {// 导航数据
      type: Array,
      required: true,
      default: () => [],
      validator(value) {
        return (Object.prototype.toString.call(value) === '[object Array]');
      },
    },
    fistLineNum: { // 第一行显示几个
      type: Number,
      default: 4,
    },
    itemClick: {// 整体点击跳转
      type: Function,
      default: (item) => {
        window.location.href = concatSoj(item.url, item.fromSoj);
      },
    },
  },
  computed: {
    year() {
      return (new Date()).getFullYear();
    },
  },
  methods: {
    goTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
<style scoped>
  .BizFooter {
    position: relative;
    font-size: 12px;
    background-color: #494949;
    text-align: center;
    padding: 10px 0;
  }
  .BizFooter .footer-icon{
    display: inline-block;
    width: 43px;
    height: 42px;
    background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFYAAABUCAMAAAAvQDDOAAAAA3NCSVQICAjb4U/gAAAAk1BMVEX///9KSkpISEhISEhGRkZERERISEhGRkZERERCQkJAQEBGRkZERERCQkJAQEA+Pj5GRkZERERCQkJAQEBGRkZERERCQkJAQEBGRkZERERCQkJISEhGRkZERERISEhGRkZISEhGRkZISEhGRkZISEhKSkpISEhmZmZdXV1bW1tYWFhXV1dUVFRSUlJQUFBOTk5KSko8riAXAAAAMXRSTlMAEREiIiIzMzMzM0REREREVVVVVWZmZmZ3d3eIiIiZmaqqu7vd7u7/////////////VBT6xAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAAAAWdEVYdENyZWF0aW9uIFRpbWUAMTIvMDUvMTRsQPO9AAADwElEQVRYhe2Z23qiMBRGK6AEsBawWu10yigIVSzy/k83OQEJ5ACh31zNf9VWXN2svRMBn57+eRYwtm2vXNcNgmCNE8BfXPhHC75mCsXI4PB5zi41zSU7J4c1RlsGYAx1g/AzqwXJknBtAEbQlSthNuQIljwJjKGvZzmT5LwDCDwearuhForBkevY4wqGVDf8MwaKcopGFYxLPVz0vCaXA9AXjKwGo86fMQGHQs3FAhTtFyfTiEDU1wkCmlx2QMFF1F8G1LrOP+RcTDWBonwAR8ydRUVccb2GXpvk0K8ACycrVFPLolRy4TwMuFBBoJ6sr6IobqoDsvVQL1SgXgUFieqQM2zbgHoYQ1Vzjz29UIFS7KMoxnDzmNcAi1XtWVXBppIfeOLKXSxWoYJaUt6Xnhu5TLnqfpXt2Tc/yQctZboGi32VU1mnjQ35oO27cpXFUtC1rr9RlbrGwXI7bKijltSAnhs3FmCxn5JjmpOuyCLDtJuamzTDIF+2VUdox+sBZagGInsm5cqnqxRQEa35b99iC6RpUgfXtuv8cihZ41ILECt0QN96r+t7wefamr6KLHgOwQYKatW5YMIJ6meD5Vor0d4l1MpyKyn3CJBckVrRCPCp5DswkStYYve2WQ8JFTvv/gOXFMsddqxs31hJqXgM6MroDRrpmR30NvCvtghBs9i0p8UPWo571h+ETtlNCmyPoafDD5oI21F10AKtZFHjCHY9NHAbR2X2oKsa269al7vgrQrst544qPI/doDtL4e5WLochNvtDGzmE6zo03wGFm41GJvoscwrWmyCtxpLeAk6A0u28YVwFGZgX5aW9CPSHEs6hrACuebYhH7yWm74k9gYkGtGKHdowRibbei1ndCCMZY6QFcKdvRz2O3Saq9vhwvNFJv67VU+bNrup7BvoLsnWdigX64hlikWl9u3a4iNPfZ+D9o98a8/rmzY6wvuhSt/RXPyubveheVEM54lNMnhGPA3vbpb6VF594a36IOuTU7qL3tUpEGwhCcl2yyHT2ughnl68+1AAeXu8hnUvZCKHlWAD3Psb1/2IMyawf3tC8QyXCMPuYKKxwGY+M33KiqpN5r+oBXNgPoBrmW764nrIt3oqHgeHHCcICJ/95daKhUcn/Q8ktPWW1qieRWJcECUjjr/eFypLdgFey04ffOh1VGlUi4yAeJE+eXL1gcQOvFbHctyHPAsIWfJ24uPpJp8B4UcA29zTNKsHY08S5Pjy8YDy8mVMmBIRmhv08b3EBIxzaCUTNBcLD3zL0ailmHgQ+2bAAAAAElFTkSuQmCC) no-repeat;
    -webkit-background-size: 43px 42px;
    background-size:  43px 42px;
    margin-top: -28px;
  }
  .BizFooter .footer-nav a {
    display: inline-block;
    color: #ddd;
    line-height: 25px;
    padding: 0 10px;
    text-decoration: none;
  }
  .BizFooter .footer-nav em {
    color: #999;
    font-style: normal;
  }
  .BizFooter .footer-copyright {
    color: #2a2a2a;
    line-height: 30px;
    text-shadow: 1px 1px 1px #565656;
  }
</style>
